import { render, staticRenderFns } from "./view.vue?vue&type=template&id=4301e8f2&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=4301e8f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4301e8f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4301e8f2')) {
      api.createRecord('4301e8f2', component.options)
    } else {
      api.reload('4301e8f2', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=4301e8f2&scoped=true&", function () {
      api.rerender('4301e8f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/iframe/view.vue"
export default component.exports